import SplitType from 'split-type';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger); 

const Type = () => {

    
    const body = document.body;
    const heroTitle = body.querySelectorAll("#hero__titles h1");
    const textSplit = new SplitType(heroTitle, {
      types: "words, chars",
      tagName: "span"
    });


    $("#hero__titles h1").each(function (index) {
      let tl = gsap.timeline({ paused: false });
      tl.from($(this).find(".word"), {
        opacity: 0,
        yPercent: 20,
        duration: 0.5,
        delay: 0.5,
        ease: "back.out(1)",
        stagger: 0.1
      });
      gsap.set($(this), { opacity: 1 });
    });


    const aniwords = gsap.utils.toArray(".js-words");

    aniwords.forEach((target) => {
      let animation = gsap.timeline({
        scrollTrigger: {
          trigger: target,
          markers: false,
          toggleActions: "play none none none"
        }
      });
      let split = new SplitType(target.querySelector(".js-words h2"), { types: "words", tagName: "span" });
      animation.from(split.words, {
        opacity: 0,
        y: 20,
        delay: 0.1,
        duration: 0.3,
        ease: "back.out(1)",
        stagger: {
          from: "start", 
          each: 0.1
        }
      });
    });



    const targets = gsap.utils.toArray(".animate-header");

    targets.forEach((target) => {
      let animation = gsap.timeline({
        scrollTrigger: {
          trigger: target,
          markers: false,
          toggleActions: "play none none none"
        }
      });
      let split = new SplitType(target.querySelector(".js-animate"), { type: "chars" });
      animation.from(split.chars, {
        opacity: 0,
        y: 20,
        delay: 0.5,
        duration: 0.5,
        ease: "back.out(1)",
        stagger: {
          from: "start", 
          each: 0.1
        }
      });
    });



    body.createScrollTrigger = function (triggerElement, timeline) {
      ScrollTrigger.create({
        trigger: triggerElement,
        start: "top bottom", // Reset tl when scroll out of view past bottom of screen
        onLeaveBack: () => {
          timeline.progress(0);
          timeline.pause();
        }
      });

      ScrollTrigger.create({
        trigger: triggerElement,
        start: "top 75%", // Play tl when scrolled into view (60% from top of screen)
        onEnter: () => timeline.play()
      });
    };

    // Set-up split text based on data attribute
    body.typeAni = function () {
      $(".portfolio__title h3").each(function (index) {
        let tl = gsap.timeline({ paused: true });
        tl.from($(this), {
          opacity: 0,
          yPercent: 60,
          duration: 0.3,
          ease: "power2.easeInOut"
          //stagger: { amount: 0.3 }
        });
        body.createScrollTrigger($(this), tl);
      });
      $(".portfolio__title p").each(function (index) {
        let tl2 = gsap.timeline({ paused: true });
        tl2.from($(this), {
          opacity: 0,
          yPercent: 60,
          duration: 0.3,
          ease: "power2.easeInOut",
          delay: 0.1
        });
        body.createScrollTrigger($(this), tl2);
      });
    };

    $(function () {
      body.typeAni();
    });
};

export { Type };
